export default "__VITE_ASSET__C1swa9X7__"